<template>
    <div style="overflow: hidden; flex: 1">
        <!--Icon Loading-->
        <div v-if="loadingMessage" class="centerXY" style="width: 100%; height: 100%">
            <v-icon class="tm-spin">mdi-loading</v-icon>
        </div>
        <!--List message-->
        <div v-else class="message-scroll px-12 py-12 fci-scrollbar"
             :class="{'no-wave-audio': !hasWaveform,'no-audio-data':!hasAudioData}">
            <div v-for="(item, j) in activeHistoryBot['messageList']" :key="j"
                 :style="[j !== 0 ? {marginTop: '12px'} : '']">
                <div v-if="item.type === 'user'" class="message-container user">
                    <div class="message user" style="max-width: 70%">
                        <div class="message-content">{{ item.content }}</div>
                        <div class="message-timestamp">{{ formatTimestamp(item.createdTime) }}</div>
                    </div>
                </div>
                <div v-else class="message-container bot">
                    <div style="width: 40px"
                         v-if="j > 0 && activeHistoryBot['messageList'][j - 1].type === 'bot'"></div>
                    <div class="message-icon-container" v-else>
                        <img src="/img/scenario/process_active.svg" alt="bot">
                    </div>
                    <div style="max-width: 70%">
                        <div class="message bot mx-2" style="flex-direction: column;"
                             v-if="canPlayAudio(item.audioLink)">
                            <div class="centerY mb-6 align-self-start" style="flex-wrap: wrap">
                                <strong class="pr-6">{{ $f.tc('audioName') }}:</strong>
                                {{ item.audioName ? item.audioName : 'unknown' }}
                            </div>
                            <audio
                                :src="item.audioLink"
                                controls="controls"
                                class="audio-custom"
                            ></audio>
                        </div>
                        <div class="message bot mx-2" v-else>
                            <div class="message-content">{{ item.content }}</div>
                            <div class="message-timestamp">{{ formatTimestamp(item.createdTime) }}</div>
                        </div>
                    </div>
                </div>
                <div v-if="item.nlp" class="nlp-container">
                                <span v-for="(entity, entityIndex) in item.nlp.entities" :key="entityIndex">
                                    ( {{ entity.entity }} - {{ entity.value }} )
                                </span>
                    <span style="color: red" class="mr-2">
                                    {{ item.nlp.intent ? item.nlp.intent.label : '' }}
                                </span>
                    <span style="color: #0052CC">
                                    {{ item.nlp.intent ? Math.round(item.nlp.intent.confidence * 100) : 100 }}%
                                </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'ScenarioHistoryTranscription',
    components: {},
    data () {
        return {

            loading: false,
            loadingMessage: false,
        }
    },
    props: {
        activeCall: {
            type: Object,
            default: () => {
            }
        },
        activeHistoryBot: {
            type: Object,
            default: () => {
            }
        },
        hasWaveform: {
            type: Boolean,
            default: () => true
        },
        hasAudioData: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        formatTimestamp (timestamp) {
            if (!timestamp) return ''

            let date

            // Check if timestamp is a number (unix timestamp)
            if (!isNaN(timestamp)) {
                // Convert to date object if it's a number
                date = new Date(Number(timestamp))
            } else {
                // If it's already a string, try to parse it
                try {
                    date = new Date(timestamp)
                    // Check if date is valid
                    if (isNaN(date.getTime())) {
                        return timestamp
                    }
                } catch (e) {
                    // If parsing fails, return the original
                    return timestamp
                }
            }

            // Format to show only time (HH:MM:SS)
            return date.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false // Use 24-hour format
            })
        },
        canPlayAudio (audioLink) {
            if (this.validURL(audioLink)) {
                let ext = audioLink.split(/[#?]/)[0].split('.').pop().trim()
                if (ext === 'wav' || ext === 'mp3') {
                    return true
                }
            }
            return false
        },
        validURL (str) {
            let pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$', 'i') // fragment locator
            return !!pattern.test(str)
        },
    }
}
</script>


<style scoped lang="scss">
@import "chat.scss";

/* Add this new style for the message content */
.message-content {
    word-break: break-word;
    white-space: pre-wrap;
}

/* Update the timestamp style */
.message-timestamp {
    width: 100%;
    font-size: 11px;
    color: #96ADD0;
    font-style: italic;
    font-family: "open sans", serif;
    text-align: end;
}

.message {
    cursor: pointer;
    display: flex;
    flex-direction: column;
}

.message-scroll {
    height: calc(100vh - 337px);
    overflow: auto;
}

/* Add styles for when wave visualization is not available */
.no-wave-audio {
    height: calc(100vh - 263px);
    overflow: auto;
}

.no-audio-data {
    height: calc(100vh - 223px);
    overflow: auto;
}

.nlp-container {
    text-align: right;
    font-size: 12px;
    margin-right: 10px;
    margin-top: 3px;
}


.item {
    font-size: 14px;
    color: #16171D;
    border-bottom: 1px solid #EDEDF2;
    padding: 10px;
    cursor: pointer;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background: #ccc;
    }
}

.audio-custom {
    height: 40px;
    width: 312px;
    border: 1px solid #FFFFFF;
    border-radius: 0 12px 12px 12px;
}

.call-audio {
    display: flex;
    align-items: center;

    audio {
        width: 100%;
        height: 30px;
    }
}


.name {
    color: #0052CC;
    cursor: pointer;
}


b {
    font-family: "open sans semi", serif;
}

.btn-tag {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    line-height: 28px;
    padding: 0 12px;
    font-size: 11px;
    text-transform: uppercase;
    font-family: "open sans semi", serif;
    white-space: nowrap;
    background: #EEF6FF;
    color: #0052CC;
    margin-right: 8px;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
        background: #C4DAF6;
    }
}

.btn-menu {
    background: #EEF6FF;
    user-select: none;
}


::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }
}
</style>
